import VueMultiselect from 'vue-multiselect';

export default {
	name: "Pagination",
	components: {
		VueMultiselect
	},
	props: {
		total: {
			type: Number,
			required: false,
			default: 10
		},
		from: {
			type: Number,
			required: false,
			default: 0
		},
		pageLength: {
			type: Number,
			required: false,
			default: 10
		}
	},
	data() {
		return {
			isDropdownClosed: false,
			pointString: '...'
		};
	},
	computed: {
		isPreviousPageDisabled() {
			return this.currentPage == 1;
		},

		isNextPageDisabled() {
			return this.totalPage[this.totalPage.length - 1] < this.currentPage + 1;
		},

		currentPage() {
			return this.from
		},

		totalPage() {
			let length = Math.ceil(this.total / this.pageLength) || 1;
			return this.getListOfPages(length);
		},

		options() {
			const options = [];
			for (let i = 1; i <= this.totalPage[this.totalPage.length-1]; i++) {
				options.push(i);
			}
			return options;
		},
		lang() {
			return window.lang || 'hu';
		}
	},
	methods: {
		goToPreviousPage() {
			if (this.currentPage > 0)this.goToPage(this.currentPage - 1);
		},

		goToNextPage() {
			if (this.totalPage[this.totalPage.length-1] >= this.currentPage+1)this.goToPage(this.currentPage + 1);
		},

		goToPage(page) {
			if (!this.isPoints(page))this.$emit('on-page-change', page);
		},

		toggleDropdown() {
			this.isDropdownClosed = !this.isDropdownClosed;
		},
		getListOfPages(pageLength) {
			const start = this.calculateStartPage(pageLength);
			const end = this.calculateEndPage(pageLength);
			let paginator = [];
			for (let i = start; i <= end; i++) {
				paginator.push(i);
			}
			paginator = this.reducePageLength(paginator, pageLength);
			this.setFirstTwoPages(paginator, pageLength);
			this.setLastTwoPages(paginator, pageLength);
			return paginator;
		},

		calculateStartPage(pageLength) {
			let start = this.currentPage - 4 > 1 ? this.currentPage - 4 : 1;
			start -= this.currentPage == pageLength ? 2 : (this.currentPage == pageLength - 1 ? 1 : 0);
			start = start < 1 ? 1 : start;
			return start;
		},
		calculateEndPage(pageLength) {
			let end = this.currentPage + 4 < pageLength ? this.currentPage + 4 : pageLength;
			end += this.currentPage == 1 ? 2 : (this.currentPage == 2 ? 1 : 0);
			return end;
		},
		reducePageLength(paginator, pageLength) {
			return paginator.slice(0, pageLength);
		},
		setFirstTwoPages(paginator, pageLength) {
			paginator[0] = 1;
			if(pageLength>1)paginator[1] = paginator[1] != 2 ? this.pointString : 2;
		},
		setLastTwoPages(paginator, pageLength) {
			paginator[paginator.length - 1] = pageLength;
			paginator[paginator.length - 2] = pageLength - 1 != paginator[paginator.length - 2] ? this.pointString : pageLength - 1;
		},
		isPoints(page) {
			return page === this.pointString;
		}
	}
}



// WEBPACK FOOTER //
// ../source/common/pagination/pagination.js